import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block, Save } from "@material-ui/icons";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import TableComponent from "app/common/Component/Table/TableComponent";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import { format2NumberAtferComma, formatMoney } from "app/common/LocalFunction";
import { pagingStaff } from "app/services/StaffService";
import { pagingDepartment } from "app/services/StoreRequestService";
import { useStore } from "app/stores";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
const SelectDepositMoneyFeePopup = ({
  open,
  handleClose,
  handleSubmit,
  handleInitAdvanceMoneyTransaction,
  initialValueDepositMoneyFee,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <PopupForm
      open={open}
      size="md"
      // height="75vh"
      handleClose={handleClose}
      title={"Sử dụng tiền cọc"}
      formik={{
        initialValues: initialValueDepositMoneyFee,
        onSubmit: handleSubmit,
        enableReinitialize: true,
      }}
      action={({ isSubmitting }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton type="submit" disabled={isSubmitting}>
              {!isMobile && <Save className="mr-2 " />}
              Áp dụng
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm
              handleInitAdvanceMoneyTransaction={
                handleInitAdvanceMoneyTransaction
              }
            />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(({ handleInitAdvanceMoneyTransaction }) => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Grid
            container
            spacing={1}
            style={{ backgroundColor: "aliceblue", marginBottom: "4px" }}
          >
            <Grid item xs={12} sm={6} md={3}>
              <GlobitsPagingAutocomplete
                name={"department"}
                label={"Cơ sở"}
                api={pagingDepartment}
                required
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <GlobitsPagingAutocomplete
                label="Người giao dịch"
                name="accountant"
                displayLabel="staffName"
                api={pagingStaff}
                searchObject={{
                  isActive: true,
                }}
                required
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <GlobitsVNDCurrencyInput
                name="totalAdvanceAmount"
                label="Tổng tiền cọc"
                disabled
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <div className="summary-box">
                <div className="summary-icon-label">
                  <AttachMoneyIcon className="summary-icon" />
                  <span className="summary-label">Tổng tiền cần thu:</span>
                </div>
                <span className="summary-value">
                  {formatMoney(values?.moneyAfterDiscount)}
                </span>
              </div>
            </Grid>
            <Grid item xs={12} md={6} className="flex flex-end">
              <CommonButton
                className="btn-primary"
                onClick={async () => {
                  if (!values?.accountant) {
                    toast.warning("Vui lòng chọn người giao dịch!");
                    return;
                  }
                  let data = await handleInitAdvanceMoneyTransaction(values);
                  setFieldValue("transItems", data?.transItems);
                  console.log("data", data);
                }}
              >
                <SyncAltIcon /> Phân bổ
              </CommonButton>
            </Grid>
            <Grid item xs={12}>
              <TableService />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} className="flex justify-end">
          <Items />
        </Grid>
      </Grid>
    </>
  );
});

const Items = () => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext();

  return (
    <Grid item sm={12}>
      <div
        style={{
          overflow: "auto",
          scrollbarWidth: "thin",
        }}
        className="table-root"
      >
        <div>
          <table className="table-container table-collapse table-layout-fixed">
            <thead className="row-table-header">
              <tr className="row-table-header">
                <th width="20" align="center">
                  <strong>STT</strong>
                </th>
                <th width="80">
                  <strong>Tên dịch vụ</strong>
                </th>

                <th width="50">
                  <strong>Thu hiện thời</strong>
                </th>

                <th width="50">
                  <strong>Dùng cọc</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {values?.transItems?.length > 0 ? (
                <>
                  {values?.transItems?.map((item, itemIndex) => {
                    return (
                      <>
                        <tr key={`item-${itemIndex}`}>
                          <td align="center">{itemIndex + 1}</td>

                          <td align="">
                            <b>{item?.invoiceItem?.invoiceItemName}</b>
                            <div>
                              SL: <b>{item?.quantity} *</b>{" "}
                              {format2NumberAtferComma(
                                item?.invoiceItem?.currentFee
                              )}
                            </div>
                          </td>

                          <td align="right">
                            <b>
                              {format2NumberAtferComma(
                                item?.invoiceItem?.currentPaymentAmount
                              )}
                            </b>
                          </td>
                          <td align="">
                            <GlobitsVNDCurrencyInput
                              name={`transItems[${itemIndex}].amount`}
                              // onChange={(e) => {
                              //   let amount = e?.target?.values;

                              //   if (
                              //     amount >
                              //     item?.invoiceItem?.currentPaymentAmount
                              //   ) {
                              //     toast.warning(
                              //       "Tiền trừ thẻ không vượt quá số tiền cần thu"
                              //     );
                              //     console.log("dd", item?.invoiceItem);
                              //     setFieldValue(
                              //       `transItems[${itemIndex}].amount`,
                              //       item?.invoiceItem?.currentPaymentAmount
                              //     );
                              //   } else {
                              //     setFieldValue(
                              //       `transItems[${itemIndex}].amount`,
                              //       amount
                              //     );
                              //   }
                              // }}
                            />
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </>
              ) : (
                <tr className="row-table-body row-table-no_data">
                  <td colSpan={4} align="center">
                    {t("noData")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Grid>
  );
};

const TableService = observer(() => {
  const { listServiceFromFeePopupSelected, listSelectedSv, setListSelectedSv } =
    useStore().feeStore.serviceFeeTabStore;
  console.log("listSelectedSv", listSelectedSv);
  return (
    <TableComponent
      data={listServiceFromFeePopupSelected || []}
      initStateRow={listSelectedSv}
      selectType="multi"
      handleChangeSelectedRows={(selectedItems) =>
        setListSelectedSv(selectedItems)
      }
      align="center"
      columns={[
        {
          field: "stt",
          title: "STT",
          align: "center",
          with: "50px",
          render: (row, index) => <span>{index + 1}</span>,
        },

        {
          field: "invoiceItemName",
          title: "Tên dịch vụ",
          render: (row) => (
            <span className="service-name">{row?.invoiceItemName}</span>
          ),
        },
        {
          field: "remaining",
          title: "Cần trả",
          render: (row) => (
            <span className="service-name">
              {formatMoney(row?.subAmountActuallyPaid)}
            </span>
          ),
        },
      ]}
    />
  );
});

export default memo(observer(SelectDepositMoneyFeePopup));
